/**
 * usePageTracking — reports every route change to /api/superadmin/page-view.
 * Fire-and-forget. Failures are silent so a tracking endpoint being down
 * never blocks the UI.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from './api';

export function usePageTracking() {
  const loc = useLocation();
  const last = useRef(null);
  useEffect(() => {
    const path = loc.pathname + (loc.search || '');
    if (path === last.current) return;
    last.current = path;
    // Only track authenticated routes (auth /me runs separately)
    if (path.startsWith('/login') || path.startsWith('/trial-signup') ||
        path.startsWith('/sp10/login') || path === '/') return;
    api.post('/superadmin/page-view', { path }).catch(() => { /* silent */ });
  }, [loc.pathname, loc.search]);
}
